<template>
  <div class="flow-modal" @click.self="$emit('close')">
    <div class="flow-modal__content" :style="{maxWidth}">
      <slot> </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'flow-modal',
  props: {
    maxWidth: {
      type: String,
      defauls: '500px',
    },
  },
};
</script>

<style lang="scss">
.flow-modal {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
